import {
  SET_PHOTOSWIPE_OPEN,
  SET_PHOTOSWIPE_INDEX,
  SET_PHOTOSWIPE_MOMENT_ID,
  SET_PHOTOSWIPE_ITEMS,
  ADD_PHOTOSWIPE_ITEMS,
  CLEAR_PHOTOSWIPE_ITEMS
} from 'shared/actions/types';

import produce from 'immer';

const initialState = {
  open: false, // set to story ID to open
  index: 0,
  momentId: null,
  items: {} // {story_id: [item, item]}
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_PHOTOSWIPE_OPEN:
      return produce(state, draft => {
        draft.open = action.payload;

        // hotfix to disable underlying action sheet
        if (draft.open) {
          window.actionSheetDisabled = true;
        } else {
          window.actionSheetDisabled = false;
        }
      });

    case SET_PHOTOSWIPE_INDEX:
      return produce(state, draft => {
        draft.index = action.payload;
        draft.momentId = null;
      });

    case SET_PHOTOSWIPE_MOMENT_ID:
      return produce(state, draft => {
        draft.momentId = action.payload;
        draft.index = null;
      });

    case SET_PHOTOSWIPE_ITEMS:
      return produce(state, draft => {
        const { storyId, items } = action.payload;

        if (Array.isArray(items)) {
          draft.items[storyId.toString()] = [...items].sort((a, b) => {
            return a.position < b.position ? -1 : 1;
          });
        }
      });

    case ADD_PHOTOSWIPE_ITEMS:
      return produce(state, draft => {
        const { storyId, items } = action.payload;

        draft.items[storyId.toString()] = draft.items[storyId.toString()] || [];

        if (Array.isArray(items)) {
          Array.prototype.push.apply(draft.items[storyId.toString()], [...items].sort((a, b) => {
            return a.position < b.position ? -1 : 1;
          }));
        }
      });

    case CLEAR_PHOTOSWIPE_ITEMS:
      return produce(state, draft => {
        const { storyId } = action.payload;
        draft.items[storyId.toString()] = [];
      });

    default:
      return state;
  }
}
